__webpack_require__.p = "https://ui-cdn.digitalocean.com/apps/registration-next/";